module.exports = __webpack_public_path__ + "static/media/envio.e43602cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/envio.png
// module id = 1196
// module chunks = 0